import React from 'react';

type DsaModalProps = {
  isOpen: boolean;
  onClose: () => void;
  product?: {
    title: string;
    advertiser: string;
  };
};

export function DsaModal({ isOpen, onClose, product }: DsaModalProps) {
  if (!isOpen) return null;

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      onClick={handleBackdropClick}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        padding: '16px',
        overflowY: 'auto'
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxWidth: '600px',
          width: '100%',
          marginTop: '40px',
          marginBottom: '40px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          position: 'relative'
        }}
      >
        {/* Close button - top right corner */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            background: 'none',
            border: 'none',
            fontSize: '32px',
            cursor: 'pointer',
            padding: '0',
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#1B1B1F',
            lineHeight: 1
          }}
          aria-label="Close"
        >
          ×
        </button>

        {/* Header with Vend logo */}
        <div
          style={{
            padding: '24px 24px 20px 24px',
            borderBottom: '1px solid #E5E5E5'
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 210 48"
            fill="#7a2822"
            aria-label="Vend logo"
            style={{
              height: '32px',
              width: 'auto'
            }}
          >
            <path d="M155.982 10.2065C145.775 10.2065 140.302 16.567 140.302 26.7735V47.0385H149.325V18.7858H162.564V46.9646H171.587V26.6995C171.587 16.4191 166.336 10.1325 156.056 10.1325L155.982 10.2065Z"></path>
            <path d="M120.925 10.2065C111.014 10.2065 104.653 17.2327 104.653 28.6965C104.653 40.1603 110.866 47.9261 121.072 47.9261C131.279 47.9261 133.867 45.9291 135.938 36.98L127.803 34.7612C126.915 39.1248 124.475 40.604 120.998 40.604C117.522 40.604 114.194 37.7196 113.824 31.0632H136.234V28.1048C136.234 15.9754 129.726 10.2065 120.925 10.2065ZM126.693 24.9985H113.898C114.564 19.3775 117.005 17.4546 120.555 17.4546C124.105 17.4546 126.693 20.265 126.693 24.3328C126.693 25.8662 126.693 26.9272 126.693 24.9985Z"></path>
            <path d="M200.653 0V17.0847C199.1 12.7211 195.328 10.2065 190.669 10.2065C182.459 10.2065 175.951 16.4191 175.951 29.0663C175.951 41.7134 182.459 48 190.669 48C198.878 48 199.1 45.4854 200.653 41.0478V47.0385H209.676V0H200.653ZM193.183 40.1602C187.784 40.1602 185.048 35.9445 185.048 29.0663C185.048 22.188 187.784 17.9723 193.183 17.9723C198.582 17.9723 200.653 22.5578 200.653 29.0663C200.653 35.5747 198.361 40.1602 193.183 40.1602Z"></path>
            <path d="M97.183 2.21881L87.1245 38.0894L76.844 2.21881H67.1553L80.9118 47.0385H93.3371L106.872 2.21881H97.183Z"></path>
            <path d="M17.8984 47.0386H26.8476V29.1403H17.8984V47.0386Z"></path>
            <path d="M8.94915 2.21881C3.99384 2.21881 0 6.21265 0 11.168V46.9646H8.94915V31.2851C8.94915 30.8413 8.94915 30.3975 8.94915 29.9538C9.61479 23.2234 15.3837 17.8983 22.3359 17.8983C29.2881 17.8983 34.983 23.2234 35.7226 29.9538C35.7226 30.3975 35.7226 30.8413 35.7226 31.2851V46.9646H44.6718V11.168C44.6718 6.21265 40.678 2.21881 35.7226 2.21881C29.584 2.21881 15.6423 2.21881 8.94915 2.21881Z"></path>
          </svg>
        </div>

        {/* Title */}
        <div style={{ padding: '32px 24px 24px 24px' }}>
          <h2
            style={{
              margin: 0,
              fontSize: '28px',
              fontWeight: 600,
              color: '#1B1B1F'
            }}
          >
            Ad information
          </h2>
        </div>

        {/* Content */}
        <div style={{ padding: '0 24px 32px 24px' }}>
          {/* About this advertiser section */}
          <div style={{ marginBottom: '40px' }}>
            <h3
              style={{
                fontSize: '20px',
                fontWeight: 600,
                marginBottom: '16px',
                color: '#1B1B1F'
              }}
            >
              About this advertiser
            </h3>
            <p style={{ margin: 0, color: '#474445', fontSize: '16px' }}>
              Paid by {product?.advertiser || 'Vend'}
            </p>
          </div>

          <div
            style={{
              height: '1px',
              backgroundColor: '#E5E5E5',
              marginBottom: '40px'
            }}
          />

          {/* Why this ad section */}
          <div style={{ marginBottom: '40px' }}>
            <h3
              style={{
                fontSize: '20px',
                fontWeight: 600,
                marginBottom: '16px',
                color: '#1B1B1F'
              }}
            >
              Why this ad?
            </h3>
            <p
              style={{
                margin: '0 0 12px 0',
                color: '#474445',
                fontSize: '16px'
              }}
            >
              This ad is based on:
            </p>
            <ul
              style={{
                margin: 0,
                paddingLeft: '24px',
                color: '#474445',
                fontSize: '16px',
                lineHeight: '1.6'
              }}
            >
              <li>Your current search</li>
            </ul>
          </div>

          <div
            style={{
              height: '1px',
              backgroundColor: '#E5E5E5',
              marginBottom: '32px'
            }}
          />

          {/* Footer with links and logo */}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <div style={{ display: 'flex', gap: '24px' }}>
              <a
                href="https://hjelpesenter.finn.no/hc/no"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#1B1B1F',
                  textDecoration: 'underline',
                  fontSize: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                Help
                <span style={{ fontSize: '12px' }}>↗</span>
              </a>
              <a
                href="https://vend.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#1B1B1F',
                  textDecoration: 'underline',
                  fontSize: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                Privacy
                <span style={{ fontSize: '12px' }}>↗</span>
              </a>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 210 48"
              fill="#7a2822"
              aria-label="Vend logo"
              style={{
                height: '24px',
                width: 'auto'
              }}
            >
              <path d="M155.982 10.2065C145.775 10.2065 140.302 16.567 140.302 26.7735V47.0385H149.325V18.7858H162.564V46.9646H171.587V26.6995C171.587 16.4191 166.336 10.1325 156.056 10.1325L155.982 10.2065Z"></path>
              <path d="M120.925 10.2065C111.014 10.2065 104.653 17.2327 104.653 28.6965C104.653 40.1603 110.866 47.9261 121.072 47.9261C131.279 47.9261 133.867 45.9291 135.938 36.98L127.803 34.7612C126.915 39.1248 124.475 40.604 120.998 40.604C117.522 40.604 114.194 37.7196 113.824 31.0632H136.234V28.1048C136.234 15.9754 129.726 10.2065 120.925 10.2065ZM126.693 24.9985H113.898C114.564 19.3775 117.005 17.4546 120.555 17.4546C124.105 17.4546 126.693 20.265 126.693 24.3328C126.693 25.8662 126.693 26.9272 126.693 24.9985Z"></path>
              <path d="M200.653 0V17.0847C199.1 12.7211 195.328 10.2065 190.669 10.2065C182.459 10.2065 175.951 16.4191 175.951 29.0663C175.951 41.7134 182.459 48 190.669 48C198.878 48 199.1 45.4854 200.653 41.0478V47.0385H209.676V0H200.653ZM193.183 40.1602C187.784 40.1602 185.048 35.9445 185.048 29.0663C185.048 22.188 187.784 17.9723 193.183 17.9723C198.582 17.9723 200.653 22.5578 200.653 29.0663C200.653 35.5747 198.361 40.1602 193.183 40.1602Z"></path>
              <path d="M97.183 2.21881L87.1245 38.0894L76.844 2.21881H67.1553L80.9118 47.0385H93.3371L106.872 2.21881H97.183Z"></path>
              <path d="M17.8984 47.0386H26.8476V29.1403H17.8984V47.0386Z"></path>
              <path d="M8.94915 2.21881C3.99384 2.21881 0 6.21265 0 11.168V46.9646H8.94915V31.2851C8.94915 30.8413 8.94915 30.3975 8.94915 29.9538C9.61479 23.2234 15.3837 17.8983 22.3359 17.8983C29.2881 17.8983 34.983 23.2234 35.7226 29.9538C35.7226 30.3975 35.7226 30.8413 35.7226 31.2851V46.9646H44.6718V11.168C44.6718 6.21265 40.678 2.21881 35.7226 2.21881C29.584 2.21881 15.6423 2.21881 8.94915 2.21881Z"></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}
